// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

/* allow full reloads on turbo actions in controller */
/* render turbo_stream: turbo_stream.action(:redirect, model_path(@model)) */
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

/** JQUERY **/
import './jquery-global'; // https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import

/** https://guides.rubyonrails.org/action_text_overview.html **/
import "trix"
import "@rails/actiontext"

/** ALPINEJS **/
import Alpine from 'alpinejs'
window.Alpine = Alpine;
Alpine.start();

import 'chartkick/chart.js'

import QrScanner from 'qr-scanner';
window.QrScanner = QrScanner;

/** PLUGINS **/
import 'flowbite';

import 'simplebar';
import 'simplebar/dist/simplebar.css';
// You will need a ResizeObserver polyfill for browsers that don't support it! (iOS Safari, Edge, ...)
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

/** CUSTOM **/
import './main';